import $ from 'jquery';

$(document).ready(function() {
	$(document).on('keyup', '.js-results-input', function() {
		if ($(this).val() !== '') {
			$('.js-results-input-clear').show();
		} else {
			$('.js-results-input-clear').hide();
		}
	});
	$(document).on('click', '.js-results-input-clear', function() {
		$('.js-results-input').val('');
		$(this).hide();
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/results/results-search.js